import { Component, HostBinding } from '@angular/core';

@Component({
    // moduleId: module.id,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent{
    currentDate : Date = new Date();
}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts